import styled from 'styled-components';

export const SeatsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  button {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1.5px solid var(--border-medium);
    background: var(--white);
    color: var(--primary);
    font-size: var(--text-xl);
    font-weight: 700;
    font-family: var(--font-brand);
    cursor: pointer;
    flex-shrink: 0;
  }

  button:hover:not(:disabled) { border-color: var(--secondary); color: var(--secondary); }
  button:disabled { opacity: 0.4; cursor: not-allowed; }

  output {
    min-width: 44px;
    text-align: center;
    font-size: var(--text-2xl);
    font-weight: 800;
  }
`;

export const AttendeeRow = styled.fieldset`
  border: 1.5px solid var(--border-light);
  border-radius: var(--radius-md);
  padding: 12px 14px 14px;
  margin: 0 0 12px;
  min-width: 0;

  legend {
    padding: 0 6px;
    font-size: var(--text-sm);
    font-weight: 700;
    color: var(--text-secondary);
  }
`;

export const MethodGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  label {
    flex: 1 1 130px;
    min-width: 0;
    cursor: pointer;
  }

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  span {
    display: block;
    text-align: center;
    padding: 11px 12px;
    border: 1.5px solid var(--border-medium);
    border-radius: var(--radius-md);
    background: var(--white);
    font-size: var(--text-sm);
    font-weight: 600;
    color: var(--text-secondary);
    transition: all var(--transition-fast);
  }

  label:hover span { border-color: var(--secondary); }

  input:checked + span {
    background: var(--primary);
    border-color: var(--primary);
    color: var(--text-on-primary);
  }

  input:focus-visible + span {
    box-shadow: 0 0 0 3px var(--focus-ring-strong);
  }
`;

export const TotalBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 16px;
  background: var(--primary-subtle);
  border-radius: var(--radius-md);
  padding: 16px 18px;
  margin: 8px 0 4px;

  .label { font-weight: 600; color: var(--text-secondary); font-size: var(--text-sm); }
  .amount { font-size: var(--text-3xl); font-weight: 800; color: var(--primary); letter-spacing: -0.5px; }
  .sub { flex-basis: 100%; font-size: var(--text-xs); color: var(--text-secondary); }

  @media (max-width: 400px) {
    .amount { font-size: var(--text-2xl); }
  }
`;

export const AvailabilityLine = styled.p`
  margin-top: 6px;
  font-size: var(--text-xs);
  font-weight: 600;
  line-height: 1.4;
  color: ${props => (props.$tone === 'bad' ? 'var(--danger)' : props.$tone === 'good' ? 'var(--success-dark)' : 'var(--text-muted)')};
`;

export const ReviewList = styled.div`
  margin-bottom: 4px;
`;
